import axiosClient from "./axiosClient";

export const listarTiposCambio = () => axiosClient.get("/tipos-cambio").then((r) => r.data);
export const upsertTipoCambio = (data) => axiosClient.post("/tipos-cambio", data).then((r) => r.data);
export const eliminarTipoCambio = (id) => axiosClient.delete(`/tipos-cambio/${id}`);
